import { createVNode as _createVNode, resolveComponent as _resolveComponent, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = /*#__PURE__*/_createVNode("div", { class: "col-xxl-12 mb-5" }, null, -1)
const _hoisted_2 = { class: "col-xxl-12" }
const _hoisted_3 = { class: "card-header border-0 pt-5 seq-pcp-header" }
const _hoisted_4 = { class: "card-title align-items-center" }
const _hoisted_5 = { class: "svg-icon svg-icon-2 me-2 text-primary" }
const _hoisted_6 = /*#__PURE__*/_createVNode("span", { class: "card-label fw-bold fs-3" }, "PCP Placement", -1)
const _hoisted_7 = { class: "card-toolbar" }
const _hoisted_8 = {
  type: "button",
  ref: "registerNewPCPButton",
  class: "btn btn-primary er fs-6 px-8 py-4",
  "data-bs-toggle": "modal",
  "data-bs-target": `#kt_register_account_modal_pcp`
}
const _hoisted_9 = { class: "card-body py-3" }
const _hoisted_10 = /*#__PURE__*/_createVNode("p", { class: "text-muted fs-8 mb-6" }, " Reminder: Kindly reposition the PCP Upgrade within 72 hours. Otherwise, the upgraded account will be automatically placed on the extreme left of the sponsor's account. ", -1)
const _hoisted_11 = { class: "table-responsive" }
const _hoisted_12 = { class: "table align-middle gs-0 gy-4" }
const _hoisted_13 = /*#__PURE__*/_createVNode("thead", null, [
  /*#__PURE__*/_createVNode("tr", { class: "text-muted fw-semibold fs-8 text-uppercase" }, [
    /*#__PURE__*/_createVNode("th", { class: "ps-4" }, "Ref. #"),
    /*#__PURE__*/_createVNode("th", null, "User ID"),
    /*#__PURE__*/_createVNode("th", null, "Name"),
    /*#__PURE__*/_createVNode("th", null, "Sponsor"),
    /*#__PURE__*/_createVNode("th", null, "Date Registered"),
    /*#__PURE__*/_createVNode("th", null, "Date Upgraded"),
    /*#__PURE__*/_createVNode("th", { class: "text-center pe-4" }, "Action")
  ])
], -1)
const _hoisted_14 = { key: 0 }
const _hoisted_15 = /*#__PURE__*/_createVNode("td", {
  colspan: "7",
  class: "text-center text-muted py-10"
}, "No PCP retailers found.", -1)
const _hoisted_16 = { class: "ps-4" }
const _hoisted_17 = { class: "text-muted fs-8" }
const _hoisted_18 = { class: "fw-semibold text-gray-800" }
const _hoisted_19 = { class: "d-flex align-items-center" }
const _hoisted_20 = { class: "seq-row-icon seq-row-icon--blue me-3" }
const _hoisted_21 = { class: "svg-icon svg-icon-3 svg-icon-white" }
const _hoisted_22 = { class: "fw-semibold text-gray-800" }
const _hoisted_23 = { class: "fw-semibold text-gray-800" }
const _hoisted_24 = { class: "text-muted fs-8" }
const _hoisted_25 = { class: "text-muted fs-8" }
const _hoisted_26 = { class: "text-muted fs-8" }
const _hoisted_27 = { class: "text-center pe-4" }
const _hoisted_28 = {
  type: "button",
  class: "btn btn-seq-view btn-sm",
  "data-bs-toggle": "modal",
  "data-bs-target": `#kt_modal_bibo_reposition`
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_skeleton = _resolveComponent("el-skeleton")
  const _component_inline_svg = _resolveComponent("inline-svg")
  const _component_RegisterRetailerModalPCP = _resolveComponent("RegisterRetailerModalPCP")
  const _component_PCP_REPOSITION_RETAILER = _resolveComponent("PCP_REPOSITION_RETAILER")

  return (_openBlock(), _createBlock(_Fragment, null, [
    _hoisted_1,
    _withDirectives(_createVNode("div", null, [
      _createVNode(_component_el_skeleton, {
        rows: 10,
        animated: ""
      })
    ], 512), [
      [_vShow, _ctx.loading]
    ]),
    _withDirectives(_createVNode("div", _hoisted_2, [
      _createVNode("div", {
        class: [_ctx.widgetClasses, "card seq-card"]
      }, [
        _createVNode("div", _hoisted_3, [
          _createVNode("h3", _hoisted_4, [
            _createVNode("span", _hoisted_5, [
              _createVNode(_component_inline_svg, { src: "media/icons/duotone/General/User.svg" })
            ]),
            _hoisted_6
          ]),
          _createVNode("div", _hoisted_7, [
            _createVNode("button", {
              type: "button",
              class: "btn btn-primary",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.registerNewEndorser()))
            }, " Encode Preferred Customer "),
            _withDirectives(_createVNode("button", _hoisted_8, " Click here ", 512), [
              [_vShow, false]
            ]),
            _createVNode(_component_RegisterRetailerModalPCP, {
              key: _ctx.modalkey,
              slotdata: _ctx.slotdata
            }, null, 8, ["slotdata"])
          ])
        ]),
        _createVNode("div", _hoisted_9, [
          _hoisted_10,
          _createVNode("div", _hoisted_11, [
            _createVNode("table", _hoisted_12, [
              _hoisted_13,
              _createVNode("tbody", null, [
                (_ctx.list.length === 0)
                  ? (_openBlock(), _createBlock("tr", _hoisted_14, [
                      _hoisted_15
                    ]))
                  : _createCommentVNode("", true),
                (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.list, (item, index) => {
                  return (_openBlock(), _createBlock("tr", { key: index }, [
                    _createVNode("td", _hoisted_16, [
                      _createVNode("span", _hoisted_17, _toDisplayString(item.recid), 1)
                    ]),
                    _createVNode("td", null, [
                      _createVNode("div", _hoisted_18, _toDisplayString(item.usid), 1)
                    ]),
                    _createVNode("td", null, [
                      _createVNode("div", _hoisted_19, [
                        _createVNode("span", _hoisted_20, [
                          _createVNode("span", _hoisted_21, [
                            _createVNode(_component_inline_svg, { src: "media/icons/duotone/General/User.svg" })
                          ])
                        ]),
                        _createVNode("div", _hoisted_22, _toDisplayString(item.usidname), 1)
                      ])
                    ]),
                    _createVNode("td", null, [
                      _createVNode("div", _hoisted_23, _toDisplayString(item.spname), 1),
                      _createVNode("div", _hoisted_24, _toDisplayString(item.spid), 1)
                    ]),
                    _createVNode("td", null, [
                      _createVNode("div", _hoisted_25, _toDisplayString(_ctx.formatDateMonthDayYear(item.regDate)), 1)
                    ]),
                    _createVNode("td", null, [
                      _createVNode("div", _hoisted_26, _toDisplayString(item.pcpSts == 1 ? _ctx.formatDateMonthDayYear(item.upgradeDate) : '—'), 1)
                    ]),
                    _createVNode("td", _hoisted_27, [
                      (item.pcpSts == 1)
                        ? (_openBlock(), _createBlock(_Fragment, { key: 0 }, [
                            _createVNode("button", _hoisted_28, " Reposition until " + _toDisplayString(_ctx.formatDateMonthDayYear(item.repositionExpiryDate)), 1),
                            _createVNode(_component_PCP_REPOSITION_RETAILER, {
                              key: index,
                              usid: item.usid
                            }, null, 8, ["usid"])
                          ], 64))
                        : _createCommentVNode("", true)
                    ])
                  ]))
                }), 128))
              ])
            ])
          ])
        ])
      ], 2)
    ], 512), [
      [_vShow, !_ctx.loading && _ctx.isShowPCPMenu == 'true']
    ])
  ], 64))
}